// '@shell-front-door' for builds whose instance sets frontDoor.domain
// (vite.config.ts). Every other build resolves src/front-door/none.ts, which
// exports the same names and carries no front-door code or styles.
import { frontDoorSignInUrl, signedOutGate } from '@omni/front-door'
import { FRONT_DOOR_APP, frontDoor } from './config'

export { LAUNCHER } from './config'
export { LauncherChrome } from './launcher/LauncherChrome'

export { AppSwitcher } from './AppSwitcher'
export { FrontDoorGate, rememberNextForSignIn } from './FrontDoorGate'

/** Signed out: the front door's sign-in address to send this page to, or null for the sign-in screen. */
export function signedOutRedirect(): string | null {
  const gate = signedOutGate({
    host: window.location.hostname,
    cookieDomain: frontDoor.cookieDomain,
    app: FRONT_DOOR_APP,
    domain: frontDoor.domain,
  })
  return gate === 'redirect' ? frontDoorSignInUrl(frontDoor.domain, window.location.href) : null
}
